import { useEffect } from 'react';
import { useStore } from '../store/useStore';

export function useKeyboard() {
  const openApp = useStore((s) => s.openApp);
  const toggleCommandPalette = useStore((s) => s.toggleCommandPalette);
  const closeWindow = useStore((s) => s.closeWindow);
  const minimizeWindow = useStore((s) => s.minimizeWindow);
  const activeWindowId = useStore((s) => s.activeWindowId);
  const toggleTheme = useStore((s) => s.toggleTheme);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const isInput = (e.target as HTMLElement)?.tagName === 'INPUT' ||
        (e.target as HTMLElement)?.tagName === 'TEXTAREA' ||
        (e.target as HTMLElement)?.isContentEditable;

      if (e.ctrlKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        toggleCommandPalette();
        return;
      }

      if (e.ctrlKey && e.key.toLowerCase() === '`') {
        e.preventDefault();
        openApp('terminal');
        return;
      }

      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 't') {
        e.preventDefault();
        toggleTheme();
        return;
      }

      // Only handle these when terminal is not focused
      if (isInput) return;

      if (e.ctrlKey && e.key.toLowerCase() === 't') {
        e.preventDefault();
        openApp('terminal');
        return;
      }

      if (e.ctrlKey && e.key.toLowerCase() === 'e') {
        e.preventDefault();
        openApp('editor');
        return;
      }

      if (e.ctrlKey && e.key.toLowerCase() === 'f') {
        e.preventDefault();
        openApp('file-manager');
        return;
      }

      if (e.ctrlKey && e.key.toLowerCase() === 'w') {
        e.preventDefault();
        if (isInput || (window.getSelection() && window.getSelection()!.toString())) return;
        if (e.ctrlKey && e.key.toLowerCase() === 'w') {
          if (activeWindowId) {
            e.preventDefault();
            closeWindow(activeWindowId);
          }
        }
        return;
      }

      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'm') {
        e.preventDefault();
        if (activeWindowId) minimizeWindow(activeWindowId);
        return;
      }

      if (e.key === 'Escape') {
        if (useStore.getState().commandPaletteOpen) {
          useStore.getState().toggleCommandPalette();
        }
        if (useStore.getState().appLauncherOpen) {
          useStore.getState().toggleAppLauncher();
        }
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [openApp, toggleCommandPalette, closeWindow, minimizeWindow, activeWindowId, toggleTheme]);
}